<template>
  <div v-if="isPersisted">
    <button
      :class="{ 'btn-primary-link': !isOnWishlist }"
      @click="clickHandler"
      type="button"
      class="btn btn-sm btn-block d-flex justify-content-center align-items-center button-wishlist"
    >
      <div
        v-if="isLoading"
        class="spinner-border spinner-border-sm text-primary spinner-thin"
      ></div>
      <i
        v-else
        :class="{ 'icon-heart-filled': isOnWishlist, 'icon-heart': !isOnWishlist }"
        class="icon i-6"
      ></i>
      <span class="text-xs pl-1">
        {{ isOnWishlist ? translations["on_wishlist"] : translations["add"] }}
      </span>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "WishlistButton",
  props: {
    translations: {
      required: true,
      type: Object,
    },
    createWishUrl: {
      required: true,
      type: String,
    },
    wishlistUrl: {
      required: true,
      type: String,
    },
    globalHashid: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      isPersisted: "currentUser/isPersisted",
      isOnWishlist: "productShow/onWishlist",
    }),
  },
  methods: {
    ...mapActions({
      setProductOnWishlist: "productShow/setProductOnWishlist",
    }),
    clickHandler() {
      if (this.isOnWishlist) {
        this.redirectToWishlist();
      } else {
        this.setProductOnWishlist({ url: this.createWishUrl, translations: this.translations });
      }
    },
    redirectToWishlist() {
      window.location.assign(this.wishlistUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.spinner-thin {
  border-width: 0.15em;
}

.button-wishlist {
  min-height: 3rem;
}
</style>
